import {html, TemplateResult} from 'lit';
import {Messages, ArticleWithStoreStock} from "../../../@types/online-reservation.js";
import {Step} from "./step.js";

export class ORSize extends Step{
  constructor(
    private readonly messages: Messages,
    private readonly onNext: () => void,
    private readonly selectSize: (size: string) => void,
    private readonly sizesWithStoreStock: ArticleWithStoreStock[] = []
  ){
    super();
  }

  protected renderContent(): TemplateResult {
    return html`
      <div class="ents-or__sizelist">
        ${this.sizesWithStoreStock.map((size: ArticleWithStoreStock) => this.renderItem(size.id, size.value))}
      </div>
    `;
  }

  protected renderFooter(): TemplateResult {
    return html``;
  }

  protected renderTitle(): TemplateResult {
    return html`
      <h2 class="ents-heading-medium" data-test-ents-or-steptwo-header>${this.messages['stepTwoHeader']}</h2>
    `;
  }

  protected renderItem(id:string, size: string): TemplateResult {
    return html`
      <label class="ents-copy-small-bold ents-or__item" data-test-ents-or-size-item>
        <input type="checkbox"
               @click="${this.selectItem(id)}"
               @keydown.enter="${this.selectItem(id)}"
               value="${size}"
               data-test-ents-or-next-button="${size}"
        />
        <div class="ents-or__size">
          <div class="ents-or__size-information" data-test-ents-or-size-item-text>
            <span>${size}</span>
          </div>
        </div>
      </label>
    `;
  }

  protected selectItem(id: string) {
    return () => {
      this.selectSize(id);
      this.onNext();
    };
  }
}
